(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-ai-question/render"] = factory(require("FEGOWebapi"));
	else
		root["/fego/component/common-ai-question/render"] = factory(root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5113__) => {
return 